import React from 'react';
import { reactLocalStorage } from 'reactjs-localstorage';
import Form from 'react-bootstrap/Form';
import Modal from 'react-bootstrap/Modal';
import FormControl from 'react-bootstrap/FormControl';
import Button from 'react-bootstrap/Button';
import Select from 'react-select';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

import RegEx from '../../util/RegEx';
import Util from '../../util/Util';
import Const from '../../util/Constants';
import EmailTemplateAPI from '../../api/EmailTemplateAPI';
import EmailAPI from '../../api/EmailAPI';

import './EmailPopup.css';

class EmailPopupNew extends React.Component {
  constructor(props) {
    super(props);

    this.options = reactLocalStorage.getObject(Const.Model).email_temp.options || [];

    let to = props.data ? props.data.email : '';
    let toError = !to || to === '' || to === '~~';

    if (!toError) to = to.substring(1, to.length - 1).replace(Const.Opt, Const.Comn);

    this.state = {
      inApiCall: false,
      temp: null,
      to,
      toError,
      cc: '',
      ccError: false,
      subject: '',
      html: '',
      isRawHtml: false,
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps && nextProps.data && nextProps.data.email !== this.props.data.email) {
      let to = nextProps.data.email || '';
      let toError = !to || to === '' || to === '~~';
      if (!toError) to = to.substring(1, to.length - 1).replace(Const.Opt, Const.Comn);
      this.setState({
        temp: null,
        to,
        toError,
        cc: '',
        ccError: false,
        subject: '',
        html: '',
        isRawHtml: false,
      });
    }
  }

  onChange = (temp) => {
    if (temp) {
      this.setState({ temp, inApiCall: true });
      const payload = {
        "template_id": temp.value,
        "sales_order~id": this.props.data.id,
        "lead~id": this.props.data.model_id,
        "project~id": this.props.data.project,
        "tower_details~id": this.props.data.tower,
        "room~id": this.props.data.room,
        "installment~id": this.props.data.installment_id
      }

      EmailTemplateAPI.htmlRender(
        payload, 
        (data) => {
          console.log({data});
          this.setState({
            subject: data?.subject,
            html: data?.html,
            isRawHtml: data?.isRawHtml,
            inApiCall: false,
          });
        },
        (err) => {
          console.error('Failed to load email template', err);
          this.setState({ inApiCall: false });
        }
      )

      // EmailTemplateAPI.get(temp.value, (email) => {
      //   let subject = '';
      //   try {
      //     const data = this.props.data || {};
      //     const fields = this.props.model?.fields || {};
      //     subject = Util.templateToData(email.subject, data, fields).template;
      //   } catch (err) {
      //     console.error('Error processing subject template:', err);
      //   }

      //   const isRawHtml = !!email.txt_body_html && email.txt_body_html.trim() !== '';

      //   let body = '';
      //   if (isRawHtml) {
      //     body = email.txt_body_html || '';
      //   } else {
      //     body = email.design?.html || '';
      //   }

      //   try {
      //     const data = this.props.data || {};
      //     const fields = this.props.model?.fields || {};
      //     body = Util.templateToData(body, data, fields).template;
      //   } catch (err) {
      //     console.error('Error processing body template:', err);
      //   }

      //   this.setState({
      //     subject,
      //     html: body,
      //     isRawHtml,
      //     inApiCall: false,
      //   });
      // }, (err) => {
      //   console.error('Failed to load email template', err);
      //   this.setState({ inApiCall: false });
      // });
    } else {
      this.setState({ temp: null, html: '', isRawHtml: false, subject: '' });
    }
  };

  onEmails = (field, text) => {
    const emails = text.split(Const.Comn);
    let hasError = false;
    for (let email of emails) {
      if (email.trim() !== '' && !RegEx.isEmail(email.trim(), '*')) {
        hasError = true;
        break;
      }
    }
    this.setState({
      [field]: text,
      [`${field}Error`]: hasError,
    });
  };

  onSubjectChange = (subject) => this.setState({ subject });

  onSave = () => {
    const { subject, to, cc, html } = this.state;

    if (!subject || subject.trim() === '') {
      Util.showNotification('Error', 'Subject cannot be empty', 'danger');
      return;
    }

    if (!to || to.trim() === '') {
      Util.showNotification('Error', 'To cannot be empty', 'danger');
      return;
    }

    if (this.state.toError || this.state.ccError) {
      Util.showNotification('Error', 'Please enter valid email addresses', 'danger');
      return;
    }

    const model_no = this.props.model_no;
    const model_id = this.props.model_id;
    const user = reactLocalStorage.getObject(Const.LoggedInUser);

    // Append user signature (if any)
    const finalHtml = html + (user?.signature || '');

    this.setState({ inApiCall: true });

    EmailAPI.send(model_no, model_id, { subject, to, cc }, finalHtml,
      () => {
        Util.showNotification('Successful', 'Email sent successfully', 'success');
        this.setState({ inApiCall: false });
        this.props.onHide();
        if (this.props.reload) this.props.reload();
      },
      (res) => {
        Util.showNotification('Failed', res.message || 'Failed to send email', 'danger');
        this.setState({ inApiCall: false });
      }
    );
  };


  render() {
    const { temp, to, toError, cc, ccError, subject, html, isRawHtml, inApiCall } = this.state;

    return (
      <Modal {...this.props} size="xl" aria-labelledby="contained-modal-title-vcenter" centered>
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">Send Email</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ overflow: 'hidden' }}>
          <Form>
            <div className="row">
              {/* Left Side: Inputs, wider */}
              <div className="col-md-4">
                <Form.Group className="mb-3" controlId="templateSelect">
                  <Form.Label>Select Template</Form.Label>
                  <Select
                    value={temp}
                    onChange={this.onChange}
                    options={this.options}
                    isSearchable
                    isClearable
                    isDisabled={inApiCall}
                  />
                </Form.Group>

                <Form.Group className="mb-3" controlId="emailTo">
                  <Form.Label>To</Form.Label>
                  <FormControl
                    type="text"
                    placeholder="Emails"
                    value={to}
                    className={toError ? 'error-w' : ''}
                    onChange={(e) => this.onEmails('to', e.target.value)}
                    disabled={inApiCall}
                  />
                  {toError && <small className="text-danger">Invalid email address(es)</small>}
                </Form.Group>

                <Form.Group className="mb-3" controlId="emailCc">
                  <Form.Label>CC</Form.Label>
                  <FormControl
                    type="text"
                    placeholder="Emails"
                    value={cc}
                    className={ccError ? 'error-w' : ''}
                    onChange={(e) => this.onEmails('cc', e.target.value)}
                    disabled={inApiCall}
                  />
                  {ccError && <small className="text-danger">Invalid email address(es)</small>}
                </Form.Group>

                <Form.Group className="mb-3" controlId="emailSubject">
                  <Form.Label>Subject</Form.Label>
                  <FormControl
                    type="text"
                    placeholder="Subject"
                    value={subject}
                    onChange={(e) => this.onSubjectChange(e.target.value)}
                    disabled={inApiCall}
                  />
                </Form.Group>
              </div>

              {/* Right Side: Editor + Preview */}
              <div className="col-md-8" style={{ maxHeight: '75vh', overflowY: 'auto' }}>
                {/* If no template selected: show editor only */}
                {!temp && (
                  <Form.Group className="mb-3" controlId="emailBodyEditor">
                    <Form.Label>Email Body</Form.Label>
                    {isRawHtml ? (
                      <textarea
                        className="form-control"
                        value={html}
                        onChange={(e) => this.setState({ html: e.target.value })}
                        style={{ height: '200px' }}
                        disabled={inApiCall}
                      />
                    ) : (
                      <CKEditor
                        editor={ClassicEditor}
                        data={html}
                        onChange={(event, editor) => {
                          const data = editor.getData();
                          this.setState({ html: data });
                        }}
                        disabled={inApiCall}
                      />
                    )}
                  </Form.Group>
                )}

                {/* If template selected: show preview only */}
                {temp && (
                  <Form.Group controlId="emailPreview" className="mt-3">
                    <Form.Label>Email Preview</Form.Label>
                    <iframe
                      title="Email Preview"
                      id="emailPreview"
                      style={{ width: '100%', height: '400px', border: '1px solid #ccc' }}
                      srcDoc={`<!DOCTYPE html><html><head><meta charset='utf-8'></head><body>${html}</body></html>`}
                      sandbox="allow-same-origin allow-scripts"
                    />
                  </Form.Group>
                )}
              </div>
            </div>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="danger" onClick={this.props.onHide} disabled={inApiCall}>
            Cancel
          </Button>

          <Button onClick={this.onSave} disabled={inApiCall || toError || ccError}>
            {inApiCall ? 'Sending...' : 'Send'}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default EmailPopupNew;
